import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.less'],
})
export class InputComponent implements OnInit, OnChanges {
    @Input() placeholder = 'Search...';
    @Input() value = '';
    @Input() isInputSearch = false;
    @Input() isFullSize = false;
    @Output() valueChange = new EventEmitter();
    @Output() refresh = new EventEmitter();

    keyword = '';

    constructor() {
    }

    input(): void {
        if (!this.isInputSearch) {
            return ;
        }
        this.refresh.emit();
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.keyword = this.value;
    }

    changeKeyword(): void {
        this.valueChange.emit(this.keyword);
    }

    clearKeyword(): void {
        this.keyword = '';
        this.valueChange.emit(this.keyword);
        this.handleRefresh();
    }

    handleRefresh(): void {
        this.refresh.emit();
    }

    enterSearch(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.handleRefresh();
        }
    }
}
